<template>
  <div class='notice atb-flex atb-flex-column'>
    <div class='tab'>
      <tab-pane :tab-list="tabList" @getCurrent="getCurrent"></tab-pane>
    </div>
    <div v-show="currentTab == 0" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="declareForm" class="atb-input" @keyup.enter.native.prevent="getList()" @submit.native.prevent>
            <el-form-item class="form-param-item" label="上级">
              <selecter v-model="declareForm.SuperiorNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="form-param-item" label="姓名">
              <selecter v-model="declareForm.WkNo" clearable></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" v-if="$auth(that, 'Commit')" @click="commitTip">提交</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="summary">
         <span class="item-data">累计参评人数:<span class="num">{{summary.totalCount||0}}</span></span>
           <span class="item-data">累计应得A人数:<span class="num">{{summary.regulationACurrentAll||0}}</span></span>
             <span class="item-data">累计应得C人数:<span class="num">{{summary.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际累计得A人数:<span :class="summary.realityACurrentAll>summary.regulationACurrentAll? warnNum: nomalNum">{{summary.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际累计得C人数:<span :class="summary.realityCCurrentAll<summary.regulationCCurrentAll? warnNum: nomalNum">{{summary.realityCCurrentAll||0}}</span></span>
                  <span class="item-data" style="color:#fe6562">（注意：评级结果为A或C时必须填写评级原因！）</span>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="unHandle"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wk" min-width="300" title="姓名" tree-node>
             <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="185" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.creationTime ? XEUtils.toDateString(new Date(row.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="90" field="ratingResult" title="OEC评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1" >{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562" >{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="115" field="isRatingInCurrentMonth" title="当月是否参评">
            <template #default="{row}">
              <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
            </template>
          </vxe-table-column>
<!--          <vxe-table-column field="creatorName" title="创建人" width="100"></vxe-table-column>-->
<!--          <vxe-table-column field="lastModifierName" title="最后修改人" width="120"></vxe-table-column>-->
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95" fixed="right">
            <template #default="{ row,column }">
              <el-tag :type="row.status == 0 ? 'unstart' : (row.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div v-show="currentTab == 1" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="authForm" class="atb-input" @keyup.enter.native.prevent="getList()" @submit.native.prevent>
            <el-form-item class="form-param-item" label="上级">
              <selecter v-model="authForm.SuperiorNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="form-param-item" label="姓名">
              <selecter v-model="authForm.WkNo" clearable></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" v-if="$auth(that, 'Commit')" @click="commitTip">提交</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="summary">
         <span class="item-data">累计参评人数:<span class="num">{{summary.totalCount||0}}</span></span>
           <span class="item-data">累计应得A人数:<span class="num">{{summary.regulationACurrentAll||0}}</span></span>
             <span class="item-data">累计应得C人数:<span class="num">{{summary.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际累计得A人数:<span :class="summary.realityACurrentAll>summary.regulationACurrentAll? warnNum: nomalNum">{{summary.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际累计得C人数:<span :class="summary.realityCCurrentAll<summary.regulationCCurrentAll? warnNum: nomalNum">{{summary.realityCCurrentAll||0}}</span></span>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="queryDeclareResult"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" min-width="100" title="NO."></vxe-table-column>
          <vxe-table-column field="wk" min-width="300" title="姓名" tree-node>
             <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.creationTime ? XEUtils.toDateString(new Date(row.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="90" field="ratingResult" title="OEC评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1" >{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562" >{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.queryDeclareResult.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="115" field="isRatingInCurrentMonth" title="当月是否参评">
            <template #default="{row}">
              <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
            </template>
          </vxe-table-column>
<!--          <vxe-table-column field="creatorName" title="创建人" width="100"></vxe-table-column>-->
<!--          <vxe-table-column field="lastModifierName" title="最后修改人" width="120"></vxe-table-column>-->
          <vxe-table-column min-width="180" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="160" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95" fixed="right">
            <template #default="{ row,column }">
              <el-tag type="complete" effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div v-if="currentTab == 2" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="form" class="atb-input" @keyup.enter.native.prevent="getHistoryList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="historyHandledHide"
                trigger="click">
                <el-tree
                  :props="defaultProps"
                  :data="historyTreeData"
                  show-checkbox
                  node-key='id'
                  ref="historyTree"
                  highlight-current
                  check-strictly
                  :default-expanded-keys="expandedData"
                  @check-change="historyHandleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="historyDepartment" placeholder="请选择部门名称" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="form.SuperiorNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <selecter v-model="form.WkNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="月份">
              <el-date-picker
                v-model="form.month"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="query-operation">
            <el-form-item class="flex-form-item" label="OEC评定结果">
              <el-select clearable v-model="form.OecResult" placeholder="OEC评定结果">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="状态">
              <common-select ref="status" v-model="form.Status" :list="OecStatusList" optLabel="itemDesc" optValue="itemValue" placeholder="状态" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getHistoryList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" v-if="$auth(that, 'HistoryExport','OEC.ManageConsole')" @click="exportExcel">导出</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table'
          border='inner'
          height='100%'
          ref="handled"
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="historyData"
          @cell-click="historyExpandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" width="150">
            <template #default="{ row }">
              <span>{{row.o.wkName? row.o.wkName + "("+row.o.wkNo+")": row.o.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wkNo" title="上级" width="150">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220">
            <template #default="{row}">{{row.o.department}}</template>
          </vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.o.year+'/'+row.o.month}}</template>
          </vxe-table-column>
          <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.o.creationTime ? XEUtils.toDateString(new Date(row.o.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingResult" title="评定结果" width="100">
             <template #default="{row}">{{row.o.ratingResult}}</template>
          </vxe-table-column>
          <!-- <vxe-table-column field="jobDate" title="入职日期" width="100">
            <template #default="{row}">
              <span>{{row.jobDate ? XEUtils.toDateString(new Date(row.jobDate), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column> -->
          <vxe-table-column field="ratingReason" title="评定原因" min-width="200">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.o.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.o.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="120">
            <template #default="{ row,column }">
              <el-tag type="complete" effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row.o[column.property])? OecStatusList.find(t=>t.itemValue==row.o[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="historyPage.PageIndex"
          :page-size.sync="historyPage.PageSize"
          :total="historyTotal"
          height="100%"
          @page-change="historyPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showCommitTip" width="300px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content" v-if="needConfirmed">
        <h2>确定要提交吗?</h2>
        <p>以下人员还未进行填报:</p>
        <el-popover
          placement="right-end"
          title="以下人员还未进行填报:"
          width="450"
          trigger="hover"
          popper-class='tipMsg'
          :content="message">
          <p slot="reference" style="color:#fe6562;margin:5px 0px;font-weight:bolder;">{{message.split('、').length>10? message.split('、').splice(0,10).join('、') + '...': message}}</p>
        </el-popover>
       
        <p>如需继续操作点击确认</p>
      </div>
      <div class="content" v-else>
        <h2>确定要提交吗?</h2>
        <p>提交之后不能修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCommitTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  export default {
    components: {
     selecter:()=>import('@/component/global/customerSelect')
    },
    name: "declare",
    data() {
      const ratingReasonValid = ({cellValue,row}) => {
        if (!cellValue && ['A', 'C'].includes(row.ratingResult)) {
          return new Error('评级结果为A、C时必须填写原因！')
        }
      }
      return {
        validRules: {
          ratingReason: [
            { validator: ratingReasonValid }
          ]
        },
        XEUtils: XEUtils,
        activeName: 'second',
        currentTab: 0,
        showHandle: false,
        handleDelete: true,
        enableHandle: true,
        tabList: [
          {
            label: '结果申报',
            id: 0,
          },
          {
            label: '申报查询',
            id: 2,
          },
        ],
        importantList: [
          {label: '否', value: false},
          {label: '是', value: true},
        ],
        oecLevel: [
          {label: 'A'},
          {label: 'B'},
          {label: 'C'},
        ],
        form: {
          month: '',
          WkName: '',
          SuperiorName:'',
          OecResult: '',
        },
        historyPage: {
          PageIndex: 1,
          PageSize: 10
        },
        historyTotal: 0,
        historyData: [],

        declareForm: {},
        authForm:{},
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        summary:{},
        warnNum:'warn-num',
        nomalNum:'num',
        OecStatusList:[],
        that:this,
        depData:[],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList:[],
        checkId:"",
        historyCheckId:"",
        department:'',
        historyDepartment:'',
        copyTreeData:[],
        departmentNo:'',
        historyDepartmentNo:'',
        row:{},
        showCommitTip:false,
        showInteriorCommitTip:false,
        showConfirmTip:false,
        expandedData:[],
        historyTreeData:[],
        historyCopyTreeData:[],
        message:'',
        currWkNo:'',
        authWkNo:'',
        needConfirmed:false,
        editJson:{},
        cacheEditJson:{},
        errMap: 1
      }
    },
    created() {
    },
    mounted() {
      const userInfo=sessionStorage.getItem('userInfo');
      this.currWkNo=userInfo? JSON.parse(userInfo).wkNo: '';
      this.getList();
      this.getOecStatus();
      this.getDep();
      this.getPersonnelAuthorization(this.currWkNo);
    },
    methods: {
      exportExcel() {
        this.$ajax.get(this.$api.manage.declare.export, {...this.form, departmentNo:this.historyDepartmentNo}, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC历史数据'
            const filetype = 'xls'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
     async getList() {
        let param={};
        let reqUrl="";
        const WkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
        const LoginWkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
        if(this.currentTab===0){
          param = (this.declareForm.WkNo||this.declareForm.SuperiorNo)? Object.assign({}, this.declareForm,{LoginWkNo:WkNo}): Object.assign({}, this.declareForm,{WkNo,LoginWkNo});
          reqUrl=(this.declareForm.WkNo||this.declareForm.SuperiorNo)? this.$api.manage.declare.listQuery: this.$api.manage.declare.listTree;
        }else{
          param = (this.authForm.WkNo||this.authForm.SuperiorNo)? Object.assign({}, this.authForm,{LoginWkNo:WkNo}): Object.assign({}, this.authForm,{WkNo,LoginWkNo});
          reqUrl=(this.authForm.WkNo||this.authForm.SuperiorNo)? this.$api.manage.declare.listQuery: this.$api.manage.declare.listTree;
        }
        await this.$ajax.get(reqUrl, param).then((res) => {
          this.tableData = res.data&&res.data.map(p=>{p.parentId=null; p.hasChild=p.isOrLeader? true: false; return p});
          this.getAnalyzeNum();
        });
      },
      loadChildren({ row }){
        const loginWkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
        return new Promise(resolve => { this.$ajax.get(this.$api.manage.declare.listTree + "?WkNo=" + row.wkNo + "&LoginWkNo=" + loginWkNo).then((res) => {
            if(res.data.length){
              resolve(res.data&&res.data.map(p=>{p.parentId=row.id; p.hasChild=p.isOrLeader? true: false; return p}));
            }else{
              row.hasChild=false;
              resolve(row);
            }
            
          });
        });
      },
      getHistoryList(resetPage) {
        if(resetPage){
          this.historyPage.PageIndex = 1;
        }
        let param = Object.assign({}, this.historyPage, this.form,{departmentNo:this.historyDepartmentNo});
        this.$ajax.get(this.$api.manage.declare.history, param).then((res) => {
          this.historyData = res.data.rows;
          this.historyTotal = res.data.total;
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
        if(this.currentTab===0){
           this.getList();
        }else if(this.currentTab===1){
           this.getList();
        }else{
          this.getHistoryList();
        }
      },
     async editClosed({row}){
      //  $table.clearValidate();
       this.errMap = null;
       this.editJson=JSON.parse(JSON.stringify(row));
       const currVal={ratingResult:row.ratingResult,ratingReason:row.ratingReason,remarks:row.remarks};
       if(JSON.stringify(this.cacheEditJson)===JSON.stringify(currVal)) {this.errMap = 1; return;}
        const $table = this.currentTab===0? this.$refs.unHandle: this.$refs.queryDeclareResult;
        this.errMap = await $table.validate(row).catch(errMap => errMap)
        if (!this.errMap) {
          this.errMap = 1;
          const {id,ratingResult,ratingReason,remarks,tag,status} = row;
          const loginWkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
          this.$ajax.post(this.$api.manage.declare.create, {id,ratingResult,ratingReason,remarks,tag,status,loginWkNo}).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      editActived({row}) {
        //InteriorUpdate:内务更新;LeaderUpdate:领导更新;PersonnelUpdate:行政更新;
        // if(row.status === 0){
        //   if(this.$auth(this, 'LeaderUpdate')&&(new Date().getDate()<10||new Date().getDate()>20)){
        //     return true;
        //   }
        // }
        // if(row.status===10){
        //   if(row.tag===1&&this.$auth(this, 'LeaderUpdate')&&(new Date().getDate()<10||new Date().getDate()>20)){
        //     return true;
        //   }
        // }
        if(row.tag===1&&this.errMap){
          const preVal={ratingResult:row.ratingResult,ratingReason:row.ratingReason,remarks:row.remarks};
          this.cacheEditJson = JSON.parse(JSON.stringify(preVal));
          return true;
        }
        return false;
      },
      save() {
        if (this.unHandleList.length) {
          this.$ajax.post(this.$api.manage.declare.createAll, this.unHandleList).then(() => {
            this.$message.success("保存成功");
          });
        }else {
          this.$ajax.post(this.$api.manage.declare.createAll, this.tableData).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      commitTip(){
        const WkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
        this.$nextTick(async ()=>{
            const $table = this.currentTab===0? this.$refs.unHandle: this.$refs.queryDeclareResult;
            const errMap = await $table.validate(true).catch(errMap => errMap)
            if (!errMap) {
              this.$ajax.get(this.$api.manage.declare.commitOecTip,{WkNoPram:WkNo},{noLoading:true}).then((res) => {
              res.message? this.needConfirmed=true: this.needConfirmed=false;
              this.message=res.message;
              }).finally(()=>{
                this.showCommitTip=true;
              });
            } 
         })
      },
      submit() {
        const WkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
        this.$ajax.get(this.$api.manage.declare.commitAllOec, {WkNo:WkNo}).then(() => {
          this.getList().then(()=>{
            this.getAnalyzeNum();
          });
          this.$message.success("提交成功");
        }).finally(()=>{
          this.showCommitTip=false;
        });
      },
      pageChange({ currentPage }) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      historyPageChange({ currentPage }) {
        this.historyPage.PageIndex = currentPage;
        this.getHistoryList();
      },
      async getAnalyzeNum(){
        const WkNo=this.currentTab===0? this.currWkNo: this.authWkNo;
        await this.$ajax.get(this.$api.manage.declare.analyzeNum, {WkNoParam: WkNo}).then((res) => {
            this.summary=res.data? res.data: {}
        });
      },
      async getOecStatus(){
         await this.$ajax.get(this.$api.common.getDict,{ItemType:'OecStatus'}).then((res) => {
            this.OecStatusList=res.data.rows||res.data||[];
         });
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row,triggerTreeNode}) {
        if(triggerTreeNode) return;
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.unHandle.updateData(this.tableData);
      },
      // eslint-disable-next-line no-unused-vars
      historyExpandRow({row, rowIndex}) {
        this.historyData[rowIndex].expandRowFlag = !this.historyData[rowIndex].expandRowFlag;
        this.$refs.handled.updateData(this.historyData);
      },
      async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList=res.data||[];     
            const obj ={};
            this.depList.forEach(v=>{
             const objClone=_.cloneDeep(obj);
             objClone.id= v.id,
             objClone.code= v.code,
             objClone.label= v.displayName
           if(v.parentId===null){
              this.expandedData.push(v.id);
              objClone.children= this.depList.filter(t=>t.parentId===v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData=_.cloneDeep(this.treeData);
              this.historyTreeData.push(objClone);
              this.historyCopyTreeData=_.cloneDeep(this.historyTreeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v=>{
          v.label= v.displayName
          v.children = this.depList.filter(t=>t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      handleCheckChange(data, checked){
        if(checked === true){
          this.checkId=data.id;
          this.departmentNo=data.code;
          this.department=data.label;
          this.$refs.tree.setCheckedKeys([data.id]);
        }else{
          if(this.checkId === data.id) {
            this.checkId='';
            this.departmentNo='';
            this.department='';
            this.$refs.tree.setCheckedKeys([]);
          }
        }
      },
      historyHandleCheckChange(data, checked){
        if(checked === true){
          this.historyCheckId=data.id;
          this.historyDepartmentNo=data.code;
          this.historyDepartment=data.label
          this.$refs.historyTree.setCheckedKeys([data.id]);
        }else{
          if(this.historyCheckId === data.id) {
            this.historyCheckId="";
            this.historyDepartmentNo="";
            this.historyDepartment="";
            this.$refs.historyTree.setCheckedKeys([]);
          }
        }
      },
      getChildrenMenu(depData){
        let depTree=[];
        depData.forEach(t=>{
          if(t.label.indexOf(this.department) != -1){
          depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData=depTree;
      },
      getHistoryChildrenMenu(depData){
        let depTree=[];
        depData.forEach(t=>{
          if(t.label.indexOf(this.historyDepartment) != -1){
          depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getHistoryChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.historyTreeData=depTree;
      },
      handledHide(){
        this.$nextTick(()=>{
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department="";
          }
        });
      },
      historyHandledHide(){
        this.$nextTick(()=>{
          if(!this.$refs.historyTree.getCheckedKeys().length){
            this.historyDepartment="";
          }
        });
      },
     async getPersonnelAuthorization(wkNo){
        await this.$ajax.get(this.$api.manage.declare.getPersonnelAuthorization + "?AuthorizedPersonNo=" + wkNo).then(res => {
          res.data&&this.tabList.push({label: '授权申报' + '~' + res.data.authorizerName + '(' + res.data.authorizerNo + ')',id: 1});
          res.data&&(this.authWkNo=res.data.authorizerNo);
        });
      }
    },
    watch:{
      department:{
        handler(val){
            const depTree=_.cloneDeep(this.copyTreeData);
            this.getChildrenMenu(depTree);
          if(!val){
            this.departmentNo="";
            this.$refs.tree&&this.$refs.tree.setCheckedKeys([]);
          }  
        },
        immediate:true
      },
      historyDepartment:{
        handler(val){
          const depTree=_.cloneDeep(this.historyCopyTreeData);
          this.getHistoryChildrenMenu(depTree);
          if(!val){
            this.historyDepartmentNo="";
            this.$refs.tree&&this.$refs.historyTree.setCheckedKeys([]);
          }  
        },
        immediate:true
      },
    }
  }
</script>
<style scoped lang='scss'>
  .notice {
    .search-wrap{
      .atb-input{
        display: flex;
        .form-param-item{
          width: 20%;
          ::v-deep .el-form-item__content{
            width: calc(100% - 50px);
            .customerSelect{
              width: 100%;
            }
          }
        }
      }
      
    }
    .search {
      .atb-input{
        display: flex;
        flex-direction: column;
        .query-where{
          display: flex;
          .flex-form-item{
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor{
              width: 100%;
            }
          }
        }
        .query-operation{
          display: flex;
        }
      }
    }
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab{
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body{
      padding-top: 33px !important;
      text-align: center;
      h2{
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p{
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer{
      text-align: center;
    }
    .summary{
      margin-bottom: 20px;
      font-size: 14px;
      color: #4a5150;
      .item-data{
        margin-right: 40px;
        .num{
          font-weight: bolder;
          color: #22b6a1;
          padding: 10px;
        }
        .warn-num{
          font-weight: bolder;
          color: #fe6562;
          padding: 10px;
        }
      }
    }
  }
</style>
<style>
  .declare-dep{
    height: 350px;
    width: 350px;
    overflow: auto;
  }
</style>